import { actionsPreprocessor } from '@/utils/redux';

const actionNames = [
  'FETCH_PROPOSALS',
  'FETCH_SUCCESS',
  'FETCH_FAILED',

  'FETCH_PROPOSAL',
  'FETCH_PROPOSAL_SUCCESS',
  'FETCH_PROPOSAL_FAILED',

  'CREATE_PROPOSAL',
  'CREATE_PROPOSAL_SUCCESS',
  'CREATE_PROPOSAL_FAILED',

  'EDIT_PROPOSAL',
  'EDIT_PROPOSAL_SUCCESS',
  'EDIT_PROPOSAL_FAILED',

  'GENERATE_PROPOSAL',
  'GENERATE_PROPOSAL_SUCCESS',
  'GENERATE_PROPOSAL_FAILED',

  'TABLE_CHANGE',
  'SET_LOADING_PERCENT',
  'ADD_CREATE_ERROR',
  'REMOVE_CREATE_ERROR',
  'CLEAR_CREATE_ERRORS',
  'SHOW_MARKETING_PREVALIDATE_MESSAGES',
  'REMOVE_MARKETING_PREVALIDATE_MESSAGE',
  'CLEAR_MARKETING_PREVALIDATE_MESSAGES',
  'UPLOAD_CUSTOM_TEMPLATE',
];

const { actions, actionTypes } = actionsPreprocessor('proposals', actionNames);

export default actions;
export { actionTypes };
